<template>

    <b-modal id="modalError" :title="title" ok-only variant="warning" :body-bg-variant="bodyBgVariant"
             :header-bg-variant="headerBgVariant" :footer-bg-variant="footerBgVariant" button-size="sm">

        <template #default="{ hide }">
            <p class="my-y justify-content-center" v-if="message!==null" v-html="message">&nbsp;</p>
        </template>

        <template #modal-footer="{ ok, cancel, hide }">
            <b-button variant="primary" @click="ok()">
                OK
            </b-button>
        </template>

    </b-modal>

</template>

<script>
import {EventBus} from "../../EventBus";

export default {
    props: {},
    data() {
        return {
            title: null,
            message: null,
            headerBgVariant: 'danger',
            bodyBgVariant: 'light',
            footerBgVariant: 'light',
        }
    },
    created() {
        EventBus.$on('modalErrorContentChanged', content => {
            if (!content.title) {
                this.title = this.$t('common.error_occurred')
            } else {
                this.title = this.$purify.sanitize(content.title)
            }
            this.message = this.$purify.sanitize(content.message);
        });
    },
    mounted() {
        console.log('Mounted ModalError (sub component).');
    }
};
</script>
